<template>
  <div class="map-container">
    <div id="map">
      <div class="search">
        <el-autocomplete
          placeholder="请输入地点"
          v-model.trim="searchPlace"
          class="input"
          :fetch-suggestions="querySearch"
          :trigger-on-focus="false"
          @select="handleSelect"
          type="text"/>
        <!-- <el-button type="primary" @click="handleMapSearch()">搜索</el-button> -->
      </div>
    </div>
  </div>
</template>

<script>
import globalKey from '@/configs/index'
import { TMap } from '@/jslib/tmap'
import { debounce } from '@/jslib/utils'
export default {
  data(){
    return{
      map: null,
      marker: null,
      loactionInfo: {
        latitude: '22.678299',
        longitude: '113.98836',
      },
      searchPlace: '',
      mapInfo: {
        detailsAddress: '',
        area: '',
        city: '',
        province: ''
      },
      restaurants: []
    }
  },
  props: {
    locationInfo: Array,
    test: Array
  },
  watch: {
    locationInfo(list){
      this.loactionInfo.latitude = list[0]
      this.loactionInfo.longitude = list[1]
      this.$nextTick(()=>{
        this.initMap();
      })
    }
  },
  // mounted(){
  //   this.$nextTick(()=>{
  //     this.initMap();
  //   })
  // },
  methods: {
    initMap() {
      let that = this
      TMap(globalKey.mapKey).then(res=>{
        let center = new qq.maps.LatLng(that.loactionInfo.latitude, that.loactionInfo.longitude)
        this.map = new qq.maps.Map(document.getElementById('map'), {
          center: center,
          zoom: 15
        })
        // 标注
        this.marker = new qq.maps.Marker({
          position: center,
          map: this.map
        })
        //点击事件
        let listener = qq.maps.event.addListener(this.map, 'click', (event) => {
          let key = globalKey.mapKey
          let location = `${event.latLng.getLat()},${event.latLng.getLng()}`
          let url = 'https://apis.map.qq.com/ws/geocoder/v1/'
          this.getMapInfo(url, key, location)
          let center = new qq.maps.LatLng(event.latLng.getLat(), event.latLng.getLng())
          this.removeMarker()
          this.marker = new qq.maps.Marker({
            position: center,
            map: this.map
          })
          this.$emit('getInfo', event.latLng.getLat(), event.latLng.getLng(), this.mapInfo)
        })
        //回调函数
        let callbacks = {
          complete:(result) => {
            let res = result.detail
            that.map.setCenter(res.location)
            let center = new qq.maps.LatLng(res.location.lat, res.location.lng)
            that.removeMarker()
            that.marker = new qq.maps.Marker({
              position: center,
              map: that.map
            })

            this.mapInfo.city = res.addressComponents.city
            this.mapInfo.area = res.addressComponents.district
            this.mapInfo.detailsAddress = res.address
            this.mapInfo.province = res.addressComponents.province

            this.$emit('getInfo', res.location.lat, res.location.lng, this.mapInfo)
          }
        }
        this.geocoder = new qq.maps.Geocoder(callbacks)
      })
    },
    removeMarker(){
      if(this.marker){
        this.marker.setMap(null)
        this.marker = null
      }
    },
    getMapInfo(url, key, location){
      this.$jsonp(url,{
        key: key,
        callbackName: 'QQmap',
	      output: 'jsonp',
	      location: location
      }).then(res=>{
        let map = res.result
        this.mapInfo.detailsAddress = map.formatted_addresses.recommend
        this.mapInfo.area = map.ad_info.district
        this.mapInfo.city = map.ad_info.city
        this.mapInfo.province = map.ad_info.province
      })
    },
    handleMapSearch(){
      this.geocoder.getLocation(this.searchPlace)
    },
    async querySearch(queryString, cb){
      let list =  await this.getLocation(queryString)
      let filterList = []
      list.forEach(item=>{
        let _obj = {
          lat: item.location.lat,
          lng: item.location.lng,
          value: `${item.province}-${item.city}-${item.district}-${item.title}`,
          city: item.city,
          area: item.district,
          province: item.province,
          detailsAddress: item.address
        }
        filterList.push(_obj)
      })
      cb(filterList);
    },
    async getLocation(keyword){
      let _res = []
      let url = 'https://apis.map.qq.com/ws/place/v1/suggestion/'
      await this.$jsonp(url,{
        key: globalKey.mapKey,
        callbackName: 'QQmap',
        output: 'jsonp',
        keyword: keyword,
	      region: '深圳'
      }).then(res=>{
        _res = res.data
      })
      return _res
    },
    handleSelect(item){
      this.map.setCenter(new qq.maps.LatLng(item.lat, item.lng))
      let center = new qq.maps.LatLng(item.lat, item.lng)
      this.removeMarker()
      this.marker = new qq.maps.Marker({
        position: center,
        map: this.map
      })

      this.mapInfo.detailsAddress = item.detailsAddress
      this.mapInfo.area = item.area
      this.mapInfo.city = item.city
      this.mapInfo.province = item.province
      this.$emit('getInfo', item.lat, item.lng, this.mapInfo)
    }
  }
}
</script>

<style lang="scss" scoped>
.map-container{
  width: 100%;
  height: 100%;
  #map{
    width: 100%;
    height: 100%;
  }
  .search{
    display: flex;
    width: 500px;;
    position: absolute;
    top: 10%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
    .input{
      margin-right: 30px;
      width: 500px;
    }
  }
}
</style>
